import lazyLoading from './lazyLoading'

export default {
  name: 'Discount',
  meta: {
    expanded: false,
    title: 'menu.discount.parent',
    iconClass: 'vuestic-icon vuestic-icon-forms'
  },
  children: [
    {
      name: 'GlobalDiscountsList',
      path: '/discounts/globals/list',
      component: lazyLoading('globalDiscounts/List'),
      meta: {
        title: 'menu.discount.globalDiscountList'
      }
    },
    {
      name: 'BrandDiscountsList',
      path: '/discounts/brands/list',
      component: lazyLoading('brandDiscounts/List'),
      meta: {
        title: 'menu.discount.brandDiscountList'
      }
    },
    {
      name: 'CategoryDiscountsList',
      path: '/discounts/categories/list',
      component: lazyLoading('categoryDiscounts/List'),
      meta: {
        title: 'menu.discount.categoryDiscountList'
      }
    },
    {
      name: 'GlobalDiscountCreate',
      path: '/discounts/globals/create',
      component: lazyLoading('globalDiscounts/Form'),
      meta: {
        title: 'menu.discount.globalDiscountCreate'
      },
      hidden: true
    },
    {
      name: 'BrandDiscountCreate',
      path: '/discounts/brands/create',
      component: lazyLoading('brandDiscounts/Form'),
      meta: {
        title: 'menu.discount.brandDiscountCreate'
      },
      hidden: true
    },
    {
      name: 'CategoryDiscountCreate',
      path: '/discounts/categories/create',
      component: lazyLoading('categoryDiscounts/Form'),
      meta: {
        title: 'menu.discount.categoryDiscountCreate'
      },
      hidden: true
    },
    {
      name: 'GlobalDiscountEdit',
      path: '/discounts/globals/edit/:id',
      component: lazyLoading('globalDiscounts/Form'),
      meta: {
        title: 'menu.discount.globalDiscountEdit'
      },
      hidden: true
    },
    {
      name: 'BrandDiscountEdit',
      path: '/discounts/brands/edit/:id',
      component: lazyLoading('brandDiscounts/Form'),
      meta: {
        title: 'menu.discount.brandDiscountEdit'
      },
      hidden: true
    },
    {
      name: 'CategoryDiscountEdit',
      path: '/discounts/categories/edit/:id',
      component: lazyLoading('categoryDiscounts/Form'),
      meta: {
        title: 'menu.discount.categoryDiscountEdit'
      },
      hidden: true
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/discount.js